/**
 * <license header>
 */

/**
 * Custom logger class that provides null-safe logging methods
 * This class is private to the package and should not be exported publicly
 */
class CustomLogger {
  private logger: any;

  /**
   * @param logger - External logger instance (can be null)
   */
  constructor(logger: any = null) {
    this.logger = logger;
  }

  /**
   * Log debug message if logger is available
   * @param message - Debug message to log
   * @param args - Additional arguments to pass to logger
   */
  debug(message: string, ...args: any[]): void {
    if (this.logger && typeof this.logger.debug === 'function') {
      this.logger.debug(message, ...args);
    }
  }

  /**
   * Log info message if logger is available
   * @param message - Info message to log
   * @param args - Additional arguments to pass to logger
   */
  info(message: string, ...args: any[]): void {
    if (this.logger && typeof this.logger.info === 'function') {
      this.logger.info(message, ...args);
    }
  }

  /**
   * Log error message if logger is available
   * @param message - Error message to log
   * @param args - Additional arguments to pass to logger
   */
  error(message: string, ...args: any[]): void {
    if (this.logger && typeof this.logger.error === 'function') {
      this.logger.error(message, ...args);
    }
  }

  /**
   * Get the underlying logger instance
   * @returns the logger instance or null
   */
  getLogger(): any {
    return this.logger;
  }
}

export default CustomLogger;
